import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  logout,
} from '../../../reducers';
import Logout from './component';

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    logout
  }, dispatch);
};

export default connect(undefined, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/component/molecules/Logout/index.js